export default {
  ID: 'id',
  SKU: 'sku',
  AMOUNT: 'amount',
  CLIENT: 'client',
  ENTRY_AMOUNT: 'entryAmount',
  LOADED: 'loaded',
  FOCUS: 'focus',
}
